module.exports = __webpack_public_path__ + "media/images/lp/lp14_02-a6b70c599577e6fd1633fe7458362e98.webp";